"use client"

import { useMutation, useQueryClient } from "@tanstack/react-query"
import {
  updateSystemNotificationSubscriptionAction,
  type SystemNotificationEventView,
  type SystemNotificationSettingsView,
} from "@/server-actions/system-notifications"
import { useTranslatedQueryHandling } from "@/hooks/use-translated-query-handling"

import { systemNotificationsQueryKey } from "@/hooks/queries/system-notifications"
import { useTranslations } from "next-intl"


export function useUpdateSystemNotificationSubscriptionMutation() {
  const withQueryHandling = useTranslatedQueryHandling()

  const tUi = useTranslations("Feedback.MutationsSystemNotifications")

  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (input: {
      eventType: string
      enabled: boolean
      channelIds: string[]
    }): Promise<SystemNotificationEventView> => {
      const result = await withQueryHandling(updateSystemNotificationSubscriptionAction(input), {
        loading: tUi("saving"),
        success: tUi("systemNotificationSaved"),
      })
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
    onSuccess: (saved) => {
      // One card saved; patch just its row so the other cards keep their pending edits.
      queryClient.setQueryData<SystemNotificationSettingsView>(systemNotificationsQueryKey, (current) =>
        current
          ? {
              ...current,
              events: current.events.map((event) =>
                event.eventType === saved.eventType ? saved : event,
              ),
            }
          : current,
      )
    },
  })
}
